const CrossIcon = (props) => (
  <svg width="12px" height="12px" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.0006 4.82166L10.1256 0.696655L11.3039 1.87499L7.17893 5.99999L11.3039 10.125L10.1256 11.3033L6.0006 7.17832L1.8756 11.3033L0.697266 10.125L4.82227 5.99999L0.697266 1.87499L1.8756 0.696655L6.0006 4.82166Z" fill={props?.fill || "currentColor"} />
  </svg>
);

export default CrossIcon;
